<template>
  <div class="mw-panel">
    <div class="mw-toolbar">
      <el-button @click="saveSet" size="mini"><i class="fa fa-file-text-o"></i> 保存</el-button>
    </div>
    <div class="mw-toolbar__body">
      <el-form class="mw-form" label-width="130px"  :model="set" ref="setForm">
        <el-col :span="24">
          <el-form-item label="默认登录应用" prop="name">
            <el-input v-model="set.defaultEnterAppId" v-show="false"></el-input>
            <el-input v-model="set.defaultEnterAppName" readOnly></el-input>
            <el-button @click="showDialog">选择</el-button>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="默认库" prop="repository">
            <el-input v-model="set.repository"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="登录页面" prop="loginPage">
            <el-input v-model="set.loginPage"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="页卡标题" prop="pageTitle">
            <el-input v-model="set.pageTitle"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="资源根路径" prop="rootPath">
            <el-input v-model="set.rootPath"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="应用资源" prop="scriptStyle">
            <div style="height: 400px">
            <mw-code-edit :value="set.scriptStyle" lang="HTML" ref="formTemplate"></mw-code-edit>
            </div>
          </el-form-item>
        </el-col>
      </el-form>
    </div>
  </div>



</template>
<script>
  export default {

    data() {
      let me = this;
      return {
        set: {
          defaultEnterAppId:'',
          defaultEnterAppName:'',
          scriptStyle:'',
          rootPath:'',
          loginPage:'',
          pageTitle:'',
          repository:''
        }
      }
    },
    mounted() {
      let me=this;
      me.mwApi.app.getSystemParameter().then((v)=>{
        if(v.result){
          let con=v.result.content;
          me.set.defaultEnterAppId=con.defaultEnterAppId;
          me.set.defaultEnterAppName=con.defaultEnterAppName;
          me.set.scriptStyle=con.scriptStyle;
          me.set.rootPath=con.rootPath;
          me.set.loginPage=con.loginPage;
          me.set.pageTitle=con.pageTitle;
          me.set.repository=con.repository;
        }
      });
    },
    methods: {
       showDialog(){
         let me=this;
         PF.show('tree',{size:'mini_large',url: this.mwUrl("/api/app/listApplicationTree"),defaultParams:{category:'application'},
           selectFirst:false,title:'选择应用',clearBtn:false,multiple:false,threeState:true, search:true, async:false,multipleLeaf:false, singleLeaf:true},function(res){
           if(res){
             me.set.defaultEnterAppId=res.id;
             me.set.defaultEnterAppName=res.name;
           }

         });
       },
       saveSet(){
         this.set.scriptStyle=this.mwRef('formTemplate').getValue();
         this.mwApi.app.saveSystemParameter({content:this.set}).then(()=>{
           this.mwMsg('保存成功');
         });
       }
    }
  }
</script>
<style scoped>
  .el-tree-node__content .el-checkbox {
    display: none;
  }

  .el-input, .el-textarea {
    width: 90%;
  }

</style>



// WEBPACK FOOTER //
// src/modules/index/views/systemSet/set/set.vue